export const TimeDelayH = (t1, t2 ) => {
 let msec= new Date(t1||new Date()).getTime() - new Date(t2);
return  Math.floor(msec / 1000 / 60 / 60);

};
